import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoutingRuleset = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3189_4366)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M19.0312 12.7032C17.3752 12.7032 15.9735 13.1316 15.0913 13.8064L8.33536 12.1289C8.12583 11.4728 7.57861 10.9021 6.81356 10.5008L5.95116 11.7954C5.511 12.3873 4.87997 12.7032 4.21875 12.7032C3.55753 12.7032 2.9265 12.3873 2.53027 11.8579L1.62441 10.5006C0.642422 11.0156 0 11.8056 0 12.7032C0 14.2565 1.88878 15.5157 4.21875 15.5157C6.10341 15.5157 7.68047 14.6862 8.22174 13.5493L14.19 15.0299C14.1455 15.1879 14.1094 15.3482 14.1094 15.5157C14.1094 16.1008 14.397 16.6311 14.8913 17.0716L11.9104 18.775C11.1395 18.4925 10.2114 18.3282 9.1875 18.3282C6.38184 18.3282 4.21875 19.5374 4.21875 21.1407C4.21875 22.744 6.38184 24 9.1875 24C11.9932 24 14.1094 22.744 14.1094 21.1407C14.1094 20.5556 13.8217 20.0253 13.3275 19.5848L16.3084 17.8814C17.0793 18.1638 18.0074 18.3282 19.0312 18.3282C21.8369 18.3282 24 17.119 24 15.5157C24 13.9124 21.8369 12.7032 19.0312 12.7032Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.65639 11.0153C3.78891 11.1925 3.99764 11.2969 4.21875 11.2969C4.43986 11.2969 4.64859 11.1925 4.78111 11.0153L7.59567 6.74766C8.14636 6.01364 8.4375 5.13956 8.4375 4.21875C8.4375 1.89239 6.54511 0 4.21875 0C1.89239 0 0 1.89239 0 4.21875C0 5.13886 0.291141 6.01364 0.841828 6.74766L3.65639 11.0153ZM4.21875 2.10938C5.38191 2.10938 6.32812 3.05559 6.32812 4.21875C6.32812 5.38191 5.38191 6.32812 4.21875 6.32812C3.05559 6.32812 2.10938 5.38191 2.10938 4.21875C2.10938 3.05559 3.05559 2.10938 4.21875 2.10938Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3189_4366",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgRoutingRuleset;
